import React from "react";
import { Helmet } from "react-helmet";
import "./ReturnPolicy.css";

function ReturnPolicy() {
  return (
    <div>
      <Helmet>
        <title>
          Return Policy | Squarefoot Flooring - Shopping Made Clear
        </title>
        <meta
          name="description"
          content="Learn about Squarefoot Flooring return policy. Understand return conditions, refund processing, fees and special conditions for different product types."
        />
      </Helmet>
      {/* ************************ breadcrumb ******************** */}

      <div className="breadcrumb mb-0">
        <div className="container">
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            {">"}
            <li>Return Policy</li>
          </ul>
        </div>
      </div>

      {/* ******************************* Return Policy ****************** */}
      <div className="return-policy-area">
        <div className="container return-policy-container">
          <div className="row">
            <div className="col-md-12 return-policy-content">
              <h1>Return Policy – hdmovietoday.xyz</h1>
              <p>If you're not completely satisfied with your purchase, we're here to help. To initiate a return, please contact our customer service team at:</p>
              <p className="contact-email">📧 <a href="mailto:customerservice@hdmovietoday.xyz">customerservice@hdmovietoday.xyz</a></p>

              <p>Please include the following in your return request:</p>
              <ul>
                <li>Your order number</li>
                <li>A list of the items to return with their product codes</li>
                <li>Photos clearly showing the current condition of each item</li>
              </ul>

              <h2>Return Conditions</h2>
              <ul>
                <li>Returns must be requested within 30 days of the original delivery date.</li>
                <li>Items must be unused, uninstalled, unaltered, and returned in their original packaging.</li>
                <li>Returns are not accepted on clearance items or special orders.</li>
                <li>Photos are required. We cannot process a return without images showing the current condition of the items.</li>
              </ul>

              <h2>Refund Processing</h2>
              <p>Once we receive and inspect your return to ensure it meets our conditions, your refund will be issued minus applicable fees.</p>

              <h2>Return Fees</h2>
              <h3>💰 Restocking Fee</h3>
              <p>A 25% restocking fee will be deducted from your refund for all approved returns.</p>

              <h3>🚚 Shipping Fees</h3>
              <p>Shipping fees vary depending on the original delivery type:</p>
              <ul>
                <li>Parcel Delivery</li>
                <li>Oversized Parcel Delivery</li>
                <li>Scheduled Delivery (Pallet Orders): A custom shipping quote will be provided before processing the return.</li>
              </ul>
              <p>Shipping arrangements for returns will be coordinated by hdmovietoday.xyz and our service partners.</p>

              <h2>Flooring & Pallet Orders – Special Conditions</h2>
              <ul>
                <li>Flooring orders must be returned in full.</li>
                <li>❌ Partial returns are not accepted.</li>
                <li>Products must be undamaged, unused, and in original packaging.</li>
                <li>Return shipping for pallet orders will be organized by hdmovietoday.xyz. A quote will be sent before finalizing your return.</li>
              </ul>

              <h2>Heat Cables & Thermostats</h2>
              <p>To qualify for a return:</p>
              <ul>
                <li>Items must be in original, undamaged packaging</li>
                <li>The box seal must be unbroken</li>
              </ul>

              <p>Have questions before initiating your return? Reach out to us — we're happy to help.</p>
              <p className="contact-email">📧 <a href="mailto:customerservice@hdmovietoday.xyz">customerservice@hdmovietoday.xyz</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReturnPolicy;